import { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { ADMIN_CONTENT_DEFAULTS } from "@/constants/adminContent";

const API_ORIGIN = process.env.REACT_APP_BACKEND_URL || "";
const API = `${API_ORIGIN}/api`;

export const resolveSiteAsset = (url) => url?.startsWith("/uploads/") ? `${API_ORIGIN}${url}` : url;

export const useSiteContent = (key) => {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage || i18n.language || "tr";
  const defaults = ADMIN_CONTENT_DEFAULTS[key] || {};
  const localizedDefaults = { ...defaults, ...(defaults.translations?.[language] || {}) };
  const [content, setContent] = useState(localizedDefaults);

  useEffect(() => {
    let active = true;
    axios.get(`${API}/content/${key}`)
      .then(({ data }) => {
        if (!active) return;
        const saved = data.data || {};
        const translations = Object.fromEntries(["en", "ro", "fr", "ar", "de", "it", "es", "pt", "ru", "az", "fa", "zh"].map((code) => [code, { ...(defaults.translations?.[code] || {}), ...(saved.translations?.[code] || {}) }]));
        const source = {
          ...defaults,
          ...saved,
          translations,
        };
        setContent({ ...source, ...(source.translations?.[language] || {}) });
      })
      .catch(() => setContent(localizedDefaults));
    return () => { active = false; };
  }, [key, language]); // eslint-disable-line react-hooks/exhaustive-deps

  return content;
};
